import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home';
import Stores from './pages/Stores';
import Cart from './pages/Cart';
import Details from './pages/Details';
import Register from './pages/Register';
import Login from './pages/Login';
import Shipping from './pages/Shipping';
import { useDispatch } from 'react-redux';
import { get_category } from './store/reducers/homeReducer'
import CategoryShops from './pages/CategoryShop';
import SearchProducts from './pages/SearchProducts';
import Payment from './pages/Payment';
import Dashboard from './pages/Dashboard';
import ProtectUser from './utils/ProtectUser';
import Index from './components/dashboard/Index';
import Orders from './components/dashboard/Orders';
import Wishlist from './components/dashboard/Wishlist';
import ChangePassword from './components/dashboard/UpdateAccountInfo';
import Order from './components/dashboard/Order';
import Chat from './components/dashboard/Chat';
import CustomerNotifications from './components/dashboard/NotificationsDark';
import ConfirmOrder from './pages/ConfirmOrder';
import StoreDetails from './pages/StoreDetails';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import UpdateAccountInfo from './components/dashboard/UpdateAccountInfo';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReturnRefundPolicy from './pages/ReturnRefundPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import FloatingCart from './components/FloatingCart';
import WishlistPage from './pages/Wishlist';
import OrderReceived from './pages/OrderReceived';
import StorePreview from './pages/StorePreview';
import StoreLayout from './components/StoreLayout';

function App() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(get_category())
  }, [])

  const host = window.location.host;
  const isCustomDomain = !host.includes('stores.mypursepay.com') &&
    !host.includes('localhost') &&
    !host.includes('dashboard.mypursepay.com') &&
    !host.includes('merchant.mypursepay.com');

  return (
    <BrowserRouter>
      <FloatingCart />
      <Routes>
        <Route path='/register' element={<Register />} />
        <Route path='/login' element={<Login />} />
        <Route path='/forgotpassword' element={<ForgotPassword />} />
        <Route path='/resetpassword' element={<ResetPassword />} />
        {isCustomDomain ? (
          <Route element={<StoreLayout />}>
            <Route path='/' element={<StoreDetails />} />
            <Route path='/shipping' element={<Shipping />} />
            <Route path='/payment' element={<Payment />} />
            <Route path='/order-received' element={<OrderReceived />} />
          </Route>
        ) : (
          <Route path='/' element={<Home />} />
        )}
        <Route path='/stores' element={<Stores />} />

        <Route element={<StoreLayout />}>
          <Route path="/stores/:storename/:storeid" element={<StoreDetails />} />
        </Route>
        <Route path='/products?' element={<CategoryShops />} />
        <Route path='/products/search?' element={<SearchProducts />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/wishlist' element={<WishlistPage />} />
        <Route path='/order/confirm?' element={<ConfirmOrder />} />
        {!isCustomDomain && <Route path='/shipping' element={<Shipping />} />}
        {!isCustomDomain && <Route path='/payment' element={<Payment />} />}
        {!isCustomDomain && <Route path='/order-received' element={<OrderReceived />} />}
        <Route path='/store-preview' element={<StorePreview />} />
        <Route path='/product/details/:slug' element={<Details />} />

        {/* Store Routes wrapped in Layout */}
        <Route path='/:storeName' element={<StoreLayout />}>
          <Route index element={<StoreDetails />} />
          <Route path='product/details/:slug' element={<Details />} />
          <Route path='cart' element={<Cart />} />
          <Route path='wishlist' element={<WishlistPage />} />
          <Route path='shipping' element={<Shipping />} />
          <Route path='payment' element={<Payment />} />
          <Route path='order-received' element={<OrderReceived />} />
          <Route path='about-us' element={<AboutUs />} />
          <Route path='privacy-policy' element={<PrivacyPolicy />} />
          <Route path='return-refund-policy' element={<ReturnRefundPolicy />} />
          <Route path='terms-and-conditions' element={<TermsAndConditions />} />
        </Route>

        <Route path='/dashboard' element={<ProtectUser />}>
          <Route path='' element={<Dashboard />}>
            <Route path='' element={<Index />} />
            <Route path='my-orders' element={<Orders />} />
            <Route path='account' element={<UpdateAccountInfo />} />
            <Route path='my-wishlist' element={<Wishlist />} />
            <Route path='order/details/:orderId' element={<Order />} />
            <Route path='chage-password' element={<ChangePassword />} />
            <Route path='notifications' element={<CustomerNotifications />} />
            <Route path='chat' element={<Chat />} />
            <Route path='chat/:sellerId' element={<Chat />} />
          </Route>
        </Route>

        {/* Policy Pages */}
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/return-refund-policy' element={<ReturnRefundPolicy />} />
        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />

        {/* Store Slug Route - Must be last to avoid conflicts */}
        {/* <Route path='/:storeName' element={<StoreDetails />} /> HANDLED BY LAYOUT ABOVE */}

      </Routes>
    </BrowserRouter>
  );
}

export default App;
